/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useEffect, useState } from "react";
import CustomCard from "../../../components/CustomCard/CustomCard";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../redux/Reducer";
import { getNegotiationActions } from "../../../redux/Action/Action";
interface CardData {
  id: string;
  title: string;
  description: string;
  relatedPhase: string;
  flag: string;
  actionType: any;
  isTrending: any;
  isMostSelected: any;
  avgRating: any;
  status: boolean;
  preselected: boolean;
  inputText: string;
  isCardSelected?: boolean;
}
interface TilesData {
  id: string;
  inputText: string;
}
interface InitialValues {
  roundName: string;
  selectedActions: TilesData[];
}
interface FinalizationRoundProps {
  onCardSelect: (selectedCards: CardData[]) => void;
  setSelectedActionTilesMap: any;
  selectedActionTilesMap: any;
  cardInputText: Record<string, string>;
  setCardInputText: React.Dispatch<
    React.SetStateAction<Record<string, string>>
  >;
}

const FinalizationPage = ({
  onCardSelect,
  setSelectedActionTilesMap,
  selectedActionTilesMap,
  cardInputText,
  setCardInputText,
}: FinalizationRoundProps) => {
  const [cardData, setCardData] = useState<CardData[]>([]);
  const dispatch = useDispatch();
  const sampleCardss = useSelector(
    (state: RootState) => state.negotiationActions.negotiationActions
  );
  const powerPositionData = useSelector(
    (state: RootState) => state.powerPosition.powerPosition
  );
  useEffect(() => {
    dispatch(getNegotiationActions());
  }, []);
  useEffect(() => {
    if (sampleCardss.length > 0) {
      const FinalizationStepCards = sampleCardss.filter(
        (item: any) =>
          item.relatedPhase === "Finalization" &&
          item.status === true &&
          !(powerPositionData === "Superior" && item.title === "Give and Take")
      );
      const formattedCards: CardData[] = FinalizationStepCards.map(
        (item: any) => ({
          ...item,
          inputText: "",
        })
      );
      // Optionally initialize any missing input text in global state
      const initialInputTexts: Record<string, string> = {};
      formattedCards.forEach((card) => {
        if (!(card.id in cardInputText)) {
          initialInputTexts[card.id] = "";
        }
      });
      if (Object.keys(initialInputTexts).length > 0) {
        setCardInputText((prev) => ({ ...prev, ...initialInputTexts }));
      }
      setCardData(formattedCards);
    }
  }, [sampleCardss]);

  useEffect(() => {
    if (cardData.length === 0) return;
    const hasSavedSelections = selectedActionTilesMap?.length > 0;
    if (!hasSavedSelections) {
      const preselectedCards = cardData.filter(card => card.preselected);
      if (preselectedCards.length > 0) {
        setSelectedActionTilesMap(preselectedCards);
        onCardSelect(preselectedCards);
      }
    }
  }, [cardData]);
  const handleCardClick = (cardId: string) => {
    const isSelected = selectedActionTilesMap.some(
      (card: CardData) => card.id === cardId
    );
    let newSelectedCards: CardData[];
    if (isSelected) {
      newSelectedCards = selectedActionTilesMap.filter(
        (card: CardData) => card.id !== cardId
      );
    } else {
      const card = cardData.find((c) => c.id === cardId);
      if (!card) return;
      const inputText = cardInputText[cardId] || "";
      newSelectedCards = [...selectedActionTilesMap, { ...card, inputText }];
    }
    setSelectedActionTilesMap(newSelectedCards);

    onCardSelect(newSelectedCards);
  };

  const handleInputChange = (cardId: string, value: string) => {
    const updatedInputTexts = {
      ...cardInputText,
      [cardId]: value,
    };
    setCardInputText(updatedInputTexts);
    const updatedCards = selectedActionTilesMap.map((card: CardData) =>
      card.id === cardId ? { ...card, inputText: value } : card
    );
    setSelectedActionTilesMap(updatedCards);

    onCardSelect(updatedCards);
  };

  return (

    <div className="negoRound-responsive-grid">
      {cardData.map((card) => (
        <div
          key={card.id}
          onClick={() => handleCardClick(card.id)}
          className="displayCards"
        >
          <CustomCard
            id={card.id}
            title={card.title}
            description={card.description}
            flag={card.flag}
            actionType={card.actionType}
            isTrending={card.isTrending}
            isMostSelected={card.isMostSelected}
            avgRating={card.avgRating}
            inputText={
              selectedActionTilesMap.find(
                (obj: CardData) => obj.id === card.id
              )?.inputText
            }
            onInputChange={(value) => handleInputChange(card.id, value)}
            isCardSelected={selectedActionTilesMap.some(
              (obj: CardData) => obj.id === card.id
            )}
          />
        </div>
      ))}
    </div>

  );
};

export default FinalizationPage;
